import { render, staticRenderFns } from "./CardRecord.vue?vue&type=template&id=fd8eee90&"
import script from "./CardRecord.vue?vue&type=script&lang=js&"
export * from "./CardRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports